import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { INAAction } from '../../model/ina-action';
import { LstQuestionValueDataView, Section } from '../model/inaSchoolEnrollments';
import { Shared } from '../../service/shared';
import { InaService } from '../../service/ina.service';
import { StepAction } from '../model/stepAction';
import { TrackingHistories, TrackingHistory } from '../../service/history';


@Component({
  selector: 'app-personal-information',
  templateUrl: './personal-information.component.html',
  styleUrls: ['./personal-information.component.scss']
})

export class PersonalInformationComponent implements OnInit {

  @Input() step: number;
  @Input() action: INAAction;

  @Output() prevOrNextStep = new EventEmitter<StepAction>();
  @Output() updateHistory =new EventEmitter<TrackingHistory>();
  
  frmPersonalInformation: UntypedFormGroup;
  section: Section;
  shared: Shared;
  notifyAction: string = '';
  inaStatusTypeId: number;
  lstTrackHistory: TrackingHistory[] = [];
  trackHistories: TrackingHistories = new TrackingHistories();

  constructor(
    private fb: UntypedFormBuilder, 
    private inaService: InaService
        ) {
    this.shared = new Shared(inaService);
    this.trackHistories.inaHistory = [];
    this.frmPersonalInformation = this.fb.group({
      name: ['',],
      qad: ['',],
      eoe: ['',],
      dob: ['',],
      radioGender: [''],
      msd: [''],
      msix: [''],
      ssid: [''],
      temporaryAddress: [''],
      currentAddress: [''],
      city: [''],
      currentAddressPhone: [''],
      district: [''],
      school: [''],
      grade: ['']

    });

  }

  ngOnInit(): void {
    let sectionId: number = 18;
    this.inaService.inaSelectionSubject$.subscribe(x => {

      this.section = x.inaSchoolEnrollment.Sections.find(x => x.SectionID == sectionId)!;
      this.inaStatusTypeId = x.inaSchoolEnrollment.InaSchoolEnrollment.StatusTypeId;
      if (!this.frmPersonalInformation.dirty) {
        this.frmPersonalInformation.reset();
        this.setFormValue();
      }
    });

    this.inaService.inaHistorySelectionSubject$.subscribe((x: TrackingHistories) => {
      if (x.inaHistory?.length >= 1) {
        this.trackHistories.inaHistory = x.inaHistory.filter(x => x.ChangedField.split(',')[0] == sectionId.toString());
      }

    });


    if (this.action == INAAction.Edit) {
      this.frmPersonalInformation.disable();
      this.radioGender.enable();
      this.temporaryAddress.enable();
      this.frmPersonalInformation.valueChanges.subscribe(() => {
        this.updateChangeValue();
      });
    }
    else if (this.action == INAAction.View) {
      this.frmPersonalInformation.disable();
    }


  }

  setFormValue() {
    this.name.setValue(this.getQuestionValue(300, 'Name'));
    this.qad.setValue(this.getQuestionValue(301, 'QAD'));
    this.eoe.setValue(this.getQuestionValue(302, 'EOE'));
    this.dob.setValue(this.getQuestionValue(303, 'DOB'));

    let genderVal = this.getQuestionValueDataCheckBox(304, 'Gender').forEach(
      x => {
        if (x.Name == 'Male' && x.Value == 'True')
          this.radioGender.setValue("1");
        else if (x.Name == 'Female' && x.Value == 'True')
          this.radioGender.setValue("2");
        else if (x.Name == 'Non-binary' && x.Value == 'True')
          this.radioGender.setValue("3");
      }
    );


    this.msd.setValue(this.getQuestionValue(308, 'MSD'));
    this.msix.setValue(this.getQuestionValue(309, 'MSIX'))
    this.ssid.setValue(this.getQuestionValue(310, 'SSID'))
    this.currentAddress.setValue(this.getQuestionValue(311, 'CurrentAddress'))
    this.temporaryAddress.setValue(this.getQuestionValue(312, 'Temporary Address') == 'True' ? true : false)
    this.city.setValue(this.getQuestionValue(313, 'City'))
    this.currentAddressPhone.setValue(this.getQuestionValue(314, 'Phone'))
    this.district.setValue(this.getQuestionValue(315, 'District'));
    this.school.setValue(this.getQuestionValue(316, 'School'));
    this.grade.setValue(this.getQuestionValue(317, 'Grade'));

  }

  getQuestionValue(questionId: number, questionName: string): string {
    return this.shared.getQuestionValue(this.section, questionId, questionName);
  }
  getQuestionValueDataCheckBox(questionId: number, questionName: string): LstQuestionValueDataView[] {
    return this.shared.getListQuestionValueData(this.section, questionId, questionName);
  }

  /*setStep(index: number) {
    this.step = index;
    let s: StepAction = new StepAction();
    s.stepNumber = this.step;
    this.prevOrNextStep.emit(s);
  }

  nextStep() {
    this.notifyAction = 'Next';
    this.notifyChanges(0);
  }

  prevStep() {
    this.notifyAction = 'Prev';
    this.notifyChanges(0);
  }
  notifyChanges(action: number) {
    let s: StepAction = new StepAction();
    s.stepNumber = 1;
    s.action = action == 1 ? '': this.notifyAction ;
    s.section = new Section();
    if (this.frmPersonalInformation.dirty) {
      this.updateChangeValue();
      s.section = this.section;
      s.lsttrackingHistory = this.lstTrackHistory;      
      this.lstTrackHistory=[];
    }    
    this.prevOrNextStep.emit(s);
  }*/


  updateChangeValue() {
    if (this.name.dirty)    
      this.setListQuestionValue(300, 'Name', this.name.value);        
    if (this.qad.dirty)
      this.setListQuestionValue(301, 'QAD', this.qad.value);
    if (this.eoe.dirty)
      this.setListQuestionValue(302, 'EOE', this.eoe.value);
    if (this.dob.dirty)
      this.setListQuestionValue(303, 'DOB', this.dob.value);
    if (this.radioGender.dirty)
    {
      this.setRadioValue(304, 'Male', this.radioGender.value)
      this.radioGender.markAsPristine();
    }
    if (this.msd.dirty)
      this.setListQuestionValue(308, 'MSD', this.msd.value);
    if (this.msix.dirty)
      this.setListQuestionValue(309, 'MSIX', this.msix.value);
    if (this.ssid.dirty)
      this.setListQuestionValue(310, 'SSID', this.ssid.value);
    if (this.currentAddress.dirty)
      this.setListQuestionValue(311, 'CurrentAddress', this.currentAddress.value);
    if (this.temporaryAddress.dirty) {
      let checkBoxVal = this.temporaryAddress.value == 1 ? 'True' : 'False';
      this.setListQuestionValue(312, 'Temporary Address', checkBoxVal);
      this.temporaryAddress.markAsPristine();
    }
    if (this.city.dirty)
      this.setListQuestionValue(313, 'City', this.city.value);
    if (this.currentAddressPhone.dirty)
      this.setListQuestionValue(314, 'Phone', this.currentAddressPhone.value);
    if (this.district.dirty)
      this.setListQuestionValue(315, 'District', this.district.value);
    if (this.school.dirty)
      this.setListQuestionValue(316, 'School', this.school.value);
    if (this.grade.dirty)
      this.setListQuestionValue(317, 'Grade', this.grade.value);
  }

  setRadioValue(questionId: number, questionName: string, value: string) {    
    this.setTrackingHistory(questionId, questionName, value);
    this.shared.setRadioValue(this.section, questionId, value);
    //this.shared.updateCacheSection(this.section);
    
  }

  setListQuestionValue(questionId: number, questionName: string, value: string) {    
    this.setTrackingHistory(questionId, questionName, value);
    this.shared.setListQuestionValue(this.section, questionId, questionName, value);
    //this.shared.updateCacheSection(this.section);
    
  }
  setTrackingHistory(questionId: number, questionName: string, value: string) {
    if (this.inaStatusTypeId == 2) {
      var tempTrackingHistory: TrackingHistory = this.shared.setTrackingHistory(this.section, questionId, questionName, value);
      this.updateHistory.emit(tempTrackingHistory);
    }
  }

  get name(): any { return this.frmPersonalInformation.get('name'); }
  get qad(): any { return this.frmPersonalInformation.get('qad'); }
  get eoe(): any { return this.frmPersonalInformation.get('eoe'); }
  get dob(): any { return this.frmPersonalInformation.get('dob'); }
  get radioGender(): any { return this.frmPersonalInformation.get('radioGender'); }
  get msd(): any { return this.frmPersonalInformation.get('msd'); }
  get msix(): any { return this.frmPersonalInformation.get('msix'); }
  get ssid(): any { return this.frmPersonalInformation.get('ssid'); }
  get temporaryAddress(): any { return this.frmPersonalInformation.get('temporaryAddress'); }
  get currentAddress(): any { return this.frmPersonalInformation.get('currentAddress'); }
  get city(): any { return this.frmPersonalInformation.get('city') }
  get currentAddressPhone(): any { return this.frmPersonalInformation.get('currentAddressPhone') }
  get district(): any { return this.frmPersonalInformation.get('district'); }
  get school(): any { return this.frmPersonalInformation.get('school'); }
  get grade(): any { return this.frmPersonalInformation.get('grade'); }

}

